import { t as uiText } from '../i18n';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useSidebarContext } from '../context/SidebarContext';
import './Sidebar.css';

interface SidebarProps {
  children?: React.ReactNode;
  forcedClosed?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ children, forcedClosed = false }) => {
  const { workspaceId } = useParams();
  const { isOpen, closeSidebarForWorkspace } = useSidebarContext();
  const isSidebarOpen = !forcedClosed && isOpen;

  return (
    <aside className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-body">{children}</div>
      <div className="sidebar-footer">
        <button
          type="button"
          className="sidebar-close-button"
          onClick={() => closeSidebarForWorkspace(workspaceId)}
          aria-label={uiText('Close the sidebar')}
          title={uiText('Close the sidebar')}
          tabIndex={isSidebarOpen ? 0 : -1}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M4 5.5h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1Z"
              stroke="currentColor"
              strokeWidth="1.6"
            />
            <path d="M9 4.5v15" stroke="currentColor" strokeWidth="1.6" />
            <path
              d="M16 9.5 13 12l3 2.5"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
